<template>
    <b-modal id="modal-add-employee" ref="modal-add-employee" title="Lista de empleados" no-enforce-focus scrollable size="lg" @hidden="handleModalClosed">
      <b-row class="my-2">
        <b-col>
          <b>Campos de busqueda</b>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-input id="search" v-model="fields.cc" trim placeholder="Ingresa el número de identificación"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input id="search" v-model="fields.fullName" trim placeholder="Ingresa nombre"></b-form-input>
        </b-col>
      </b-row>
      <br/>
      <b-row class="mb-1">
        <b-col>
          <b>Selecciona uno o más empleados</b>
        </b-col>
      </b-row>
      <b-table ref="table-employees" :fields="columns" :items="data.employees" hover
      head-variant="light" responsive selectable select-mode="multi" @row-selected="onRowSelected">
        <template #cell(check)="{ rowSelected }">
          <template v-if="rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
          </template>
          <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
          </template>
        </template>
      </b-table>
      <template #modal-footer>
        <b-button @click="$bvModal.hide('modal-add-employee')" variant="secondary" size="sm" class="mr-0 mb-3 mt-3">Cancelar</b-button>
        <b-button class="ml-0" variant="primary" @click="addEmployees()">
            Agregar
        </b-button>
      </template>
    </b-modal>
</template>

<script>
import apiClient2 from '@/services/axios/v2.js'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 8000,
  timerProgressBar: true,
  color: '#595c97',
  width: '600px',
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'ModalAddEmployees',
  props: {
    month: Number,
    year: Number,
  },
  data() {
    return {
      data: {
        employees: {},
      },
      columns: [
        {
          label: 'Check',
        },
        {
          label: 'Número de identificación',
          key: 'user.cc',
        },
        {
          label: 'Nombre',
          key: 'user.fullName',
        },
      ],
      fields: {
        cc: '',
        fullName: '',
        isHired: true,
      },
      typingTimer: '',
      selected: [],
      pagination: {
        currentPage: 1,
      },
    }
  },
  created() {
    apiClient2.get('/employees?isHired=true')
      .then((res) => {
        const { data } = res
        this.data.employees = data.data.employees
      })
      .catch((err) => console.log(err))
  },
  methods: {
    addEmployees() {
      if (this.selected.length !== 0) {
        apiClient2.post('/payrolls/periods/employees', {
          employees: this.selected.map((e) => e.id),
          period: {
            month: this.month,
            year: this.year,
          },
        })
          .then((res) => {
            const { data } = res
            this.selected = []
            if (data.success) {
              Toast.fire({
                icon: 'success',
                title: data.message,
              })
              this.$emit('refreshData')
              this.$refs['modal-add-employee'].hide()
            }
          })
          .catch((err) => {
            console.log(err)
            Toast.fire({
              icon: 'warning',
              title: `${err.response.data.error.message}`,
            })
          })
      } else {
        Toast.fire({
          icon: 'warning',
          title: '¡No has seleccionado ningún empleado!',
        })
      }
    },
    onRowSelected(items) {
      this.selected = items
    },
    handleModalClosed() {
      this.selected = []
    },
    searchEmployees() {
      const query = {}
      const keys = Object.keys(this.fields)
      // Guardamos las propiedades para hacer un recorrido de los parametros
      for (const key of keys) {
        if (this.fields[key] !== '' && this.fields[key] !== 'false') {
          query[key] = this.fields[key]
        }
      }
      apiClient2.get('employees', { params: query }).then((res) => {
        const { data } = res
        this.data.employees = data.data.employees
      })
        .catch((err) => console.log(err))
    },
    debounce() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.searchEmployees() }, 500)
    },
  },
  watch: {
    year: function (newYear) {
      if (newYear) {
        this.year = newYear
      }
    },
    month: function (newMonth) {
      if (newMonth) {
        this.month = newMonth
      }
    },
    'fields.cc': function(val) {
      this.debounce(val, 250)
    },
    'fields.fullName': function(val) {
      this.debounce(val, 250)
    },
  },
}

</script>
